import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import AOS from 'aos';
import { Form, message } from 'antd';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { submitForm } from '../../redux/actions/submit';
import { uploadOneFile, uploadFileContact } from '../../redux/actions/upload';
import { toast, ToastContainer } from 'react-nextjs-toast';
const formRef = React.createRef();
import useTrans from '../../hooks/useTrans';
import { validateEmailWithoutSpecial, validatePhoneNumber } from '../../lib/common';
import MetaSeo from '../MetaSeo';

export default function Contact(props) {
  const dispatch = useDispatch();
  const fileref = useRef(null);
  const [fileupload, setFile] = useState(null);
  const trans = useTrans();
  const OnSubmit = async () => {
    await formRef.current.validateFields();
    let error_handle = false;
    let {
      name, email, mobile,
      title, note, purpose
    } = formRef.current.getFieldsValue();
    let image = "";
    if (fileupload) {
      let newUploadFile = new FormData();
      newUploadFile.append('file', fileupload);
      image = await uploadFileContact(newUploadFile);
      if (!image || image === '') {
        error_handle = true;
      }
    }
    let dataPush = {
      name, email, mobile,
      title, note, url: image, other_data: { purpose },
      type: 'contact'
    };
    if (error_handle === false) {
      const res = await submitForm(dataPush);
      if (res.code === 200) {
          message.success('送信されました');
          formRef.current.resetFields();
          setFile(null);
      } else {
        message.false('エラーが発生しました');
      }
    }
  };
  const regexPhoneNumber = /^((\+)84|0)[1-9](\d{2}){4}$/;

  const trimInput = (key, e) => {
    let { value } = e.target;
    formRef.current.setFieldsValue({ [key]: value.trim() });
  };

  const dataSeo = {
    url: process.env.NEXT_PUBLIC_SEO_URL,
    type: 'website',
    title: "問い合わせ | TCOM JAPAN",
    description: 'アドバイス、見積もり、またはビジネス協力連絡先の情報を送信します。 いつでもメールでお問い合わせください。 私たちはあなたの声に耳を傾け、サポートする準備ができています。',
    domain: process.env.NEXT_PUBLIC_DOMAIN,
    // image: 'https://staging.tcom-japan.com/assets/images/about/gallery-2.png',
    card: 'summary_large_image',
  };

  return (
    <>
      <MetaSeo {...dataSeo} />
      <div className='main-content'>
        <div className='r-contact-form'>
          <div className='container'>
            <ToastContainer position={'top'}/>
            <div className='row'>
              <div className='col-12 col-md-6'>
                <div className='info'>
                  <h1>{trans.contact.contact_title}</h1>
                  <p className='desc'>{trans.contact.contact_text1}<br />{trans.contact.contact_text2}</p>
                  <div className='block'>
                    <h3>
                      {trans.contact.tcom_japan}
                      <svg width={39} height={29} viewBox='0 0 39 29' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path d='M39 0.851074H0V28.1414H39V0.851074Z' fill='#F1F0F0' />
                        <path d='M19.4944 6.46729C23.9151 6.46729 27.4927 10.0587 27.4927 14.4965C27.4927 18.9343 23.9151 22.5257 19.4944 22.5257C15.0737 22.5257 11.4961 18.9343 11.4961 14.4965C11.4961 10.0587 15.0737 6.46729 19.4944 6.46729Z' fill='#D61F30' />
                      </svg>
                    </h3>
                    <ul>
                      <li>
                        <span className='icon'>
                          <svg width={32} height={32} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <rect width={32} height={32} rx={4} fill='#E7F8FF' />
                            <path d='M16 17C17.6569 17 19 15.6569 19 14C19 12.3431 17.6569 11 16 11C14.3431 11 13 12.3431 13 14C13 15.6569 14.3431 17 16 17Z' stroke='#0063AA' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round' />
                            <path d='M16 6C13.8783 6 11.8434 6.84285 10.3431 8.34315C8.84285 9.84344 8 11.8783 8 14C8 15.892 8.402 17.13 9.5 18.5L16 26L22.5 18.5C23.598 17.13 24 15.892 24 14C24 11.8783 23.1571 9.84344 21.6569 8.34315C20.1566 6.84285 18.1217 6 16 6V6Z' stroke='#0063AA' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round' />
                          </svg>
                        </span>
                        <span>〒190-0023 東京都立川市柴崎町3-8-5 </span>
                      </li>
                      <li>
                        <div className='icon'>
                          <svg width={32} height={32} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <rect width={32} height={32} rx={4} fill='#E7F8FF' />
                            <path fillRule='evenodd' clipRule='evenodd' d='M21 27C21.5304 27 22.0391 26.7893 22.4142 26.4142C22.7893 26.0391 23 25.5304 23 25V7C23 6.46957 22.7893 5.96086 22.4142 5.58579C22.0391 5.21071 21.5304 5 21 5H11C10.4696 5 9.96086 5.21071 9.58579 5.58579C9.21071 5.96086 9 6.46957 9 7V25C9 25.5304 9.21071 26.0391 9.58579 26.4142C9.96086 26.7893 10.4696 27 11 27H21ZM15 25H11V7H21V25H17V23.969C17 23.7038 16.8946 23.4494 16.7071 23.2619C16.5196 23.0744 16.2652 22.969 16 22.969C15.7348 22.969 15.4804 23.0744 15.2929 23.2619C15.1054 23.4494 15 23.7038 15 23.969V25Z' fill='#0063AA' />
                          </svg>
                        </div>
                        <span>042 512 9160</span>
                      </li>
                      <li>
                        <div className='icon'>
                          <svg width={32} height={32} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <rect width={32} height={32} rx={4} fill='#E7F8FF' />
                            <path d='M23 8H9C8.20435 8 7.44129 8.31607 6.87868 8.87868C6.31607 9.44129 6 10.2044 6 11V21C6 21.7956 6.31607 22.5587 6.87868 23.1213C7.44129 23.6839 8.20435 24 9 24H23C23.7956 24 24.5587 23.6839 25.1213 23.1213C25.6839 22.5587 26 21.7956 26 21V11C26 10.2044 25.6839 9.44129 25.1213 8.87868C24.5587 8.31607 23.7956 8 23 8ZM22.33 10L16 14.75L9.67 10H22.33ZM23 22H9C8.73478 22 8.48043 21.8946 8.29289 21.7071C8.10536 21.5196 8 21.2652 8 21V11.25L15.4 16.8C15.5731 16.9298 15.7836 17 16 17C16.2164 17 16.4269 16.9298 16.6 16.8L24 11.25V21C24 21.2652 23.8946 21.5196 23.7071 21.7071C23.5196 21.8946 23.2652 22 23 22Z' fill='#0063AA' />
                          </svg>
                        </div>
                        <span>{trans.layout.email_tcomjp}</span>
                      </li>
                      <li>
                        <div className='icon'>
                          <svg width={32} height={33} viewBox='0 0 32 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <rect y='0.259766' width={32} height={32} rx={4} fill='#E7F8FF' />
                            <g clipPath='url(#clip0_133_252)'>
                              <path d='M25.284 17.4918L24.5565 17.395C24.5322 17.5728 24.574 17.7533 24.6739 17.9024L25.2825 17.4918H25.284ZM14.768 6.97577L14.3573 7.58444C14.5054 7.68413 14.6848 7.72637 14.8619 7.70324L14.7665 6.97577H14.768ZM6.716 15.0278L7.44347 15.1231C7.4674 14.9458 7.42567 14.7658 7.32613 14.6171L6.716 15.0278ZM17.232 25.5438L17.6412 24.9351C17.4925 24.8356 17.3125 24.7938 17.1352 24.8178L17.232 25.5438ZM26.01 17.59C26.0672 17.1647 26.1068 16.7203 26.1068 16.2598H24.6401C24.6401 16.6367 24.6079 17.0122 24.5565 17.395L26.0085 17.59H26.01ZM26.1068 16.2598C26.1064 13.5794 25.0415 11.0089 23.1462 9.11361C21.2508 7.2183 18.6804 6.15336 16 6.15297V7.61964C18.2914 7.62003 20.4888 8.53045 22.1091 10.1507C23.7293 11.771 24.6397 13.9684 24.6401 16.2598H26.1068ZM16 6.15297C15.538 6.15297 15.0951 6.19404 14.6727 6.2483L14.8619 7.70324C15.2491 7.65337 15.6245 7.61964 16 7.61964V6.15297ZM15.1757 6.3671C14.1001 5.64385 12.8331 5.25827 11.5369 5.25977V6.72644C12.5812 6.72644 13.5521 7.04324 14.3573 7.58444L15.1757 6.3671ZM11.5369 5.25977C10.6784 5.25958 9.82831 5.42853 9.03513 5.75697C8.24195 6.08542 7.52124 6.56691 6.91419 7.17396C6.30715 7.78101 5.82565 8.50171 5.4972 9.2949C5.16876 10.0881 4.99981 10.9382 5 11.7967H6.46667C6.46647 11.1308 6.59749 10.4714 6.85223 9.85617C7.10696 9.24093 7.48043 8.68191 7.95128 8.21105C8.42214 7.7402 8.98116 7.36673 9.5964 7.11199C10.2116 6.85726 10.871 6.72624 11.5369 6.72644V5.25977ZM5 11.7967C5 13.1431 5.4092 14.3956 6.10733 15.4355L7.32467 14.6171C6.76393 13.7835 6.46514 12.8013 6.46667 11.7967H5ZM5.99 14.931C5.9285 15.3713 5.89616 15.8152 5.8932 16.2598H7.35987C7.35987 15.8828 7.39213 15.5074 7.44347 15.1231L5.99 14.931ZM5.8932 16.2598C5.8932 18.9403 6.95802 21.511 8.85341 23.4064C10.7488 25.3017 13.3195 26.3666 16 26.3666V24.8999C13.7085 24.8999 11.5108 23.9896 9.8905 22.3693C8.27016 20.7489 7.35987 18.5513 7.35987 16.2598H5.8932ZM16 26.3666C16.4605 26.3666 16.9035 26.327 17.3288 26.2698L17.1352 24.8178C16.759 24.8701 16.3798 24.8975 16 24.8999V26.3666ZM16.8228 26.1524C17.8641 26.852 19.1167 27.2598 20.4631 27.2598V25.7931C19.458 25.7946 18.4753 25.4959 17.6412 24.9351L16.8228 26.1524ZM20.4631 27.2598C22.1968 27.2598 23.8595 26.5711 25.0854 25.3451C26.3113 24.1192 27 22.4565 27 20.7228H25.5333C25.5333 21.3887 25.4022 22.048 25.1474 22.6631C24.8926 23.2783 24.5191 23.8372 24.0483 24.3081C23.5775 24.7789 23.0185 25.1523 22.4034 25.4072C21.7882 25.662 21.1289 25.7931 20.4631 25.7931V27.2598ZM27 20.7228C27 19.3764 26.5893 18.1239 25.8912 17.084L24.6739 17.9024C25.2165 18.7091 25.5333 19.6771 25.5333 20.7243H27V20.7228ZM15.2667 16.9931H16.7333V15.5264H15.2667V16.9931ZM19.5889 12.9979C19.3076 12.4355 18.8753 11.9626 18.3404 11.6321C17.8055 11.3015 17.1891 11.1264 16.5603 11.1264V12.5931C17.2877 12.5931 17.9521 13.0038 18.2763 13.655L19.5889 12.9979ZM18.2 18.4598C18.2 18.8488 18.0455 19.2218 17.7704 19.4969C17.4954 19.7719 17.1223 19.9264 16.7333 19.9264V21.3931C17.5113 21.3931 18.2574 21.0841 18.8075 20.5339C19.3576 19.9838 19.6667 19.2377 19.6667 18.4598H18.2ZM16.7333 16.9931C17.1223 16.9931 17.4954 17.1476 17.7704 17.4227C18.0455 17.6977 18.2 18.0708 18.2 18.4598H19.6667C19.6667 17.6818 19.3576 16.9357 18.8075 16.3856C18.2574 15.8355 17.5113 15.5264 16.7333 15.5264V16.9931ZM15.4397 19.9264C14.7123 19.9264 14.0464 19.5158 13.7237 18.8646L12.4111 19.5216C12.6924 20.084 13.1247 20.5569 13.6596 20.8875C14.1945 21.218 14.8109 21.3931 15.4397 21.3931V19.9264ZM12.3333 14.0598C12.3333 14.8377 12.6424 15.5838 13.1925 16.1339C13.7426 16.6841 14.4887 16.9931 15.2667 16.9931V15.5264C14.8777 15.5264 14.5046 15.3719 14.2296 15.0969C13.9545 14.8218 13.8 14.4488 13.8 14.0598H12.3333ZM13.8 14.0598C13.8 13.6708 13.9545 13.2977 14.2296 13.0227C14.5046 12.7476 14.8777 12.5931 15.2667 12.5931V11.1264C14.4887 11.1264 13.7426 11.4355 13.1925 11.9856C12.6424 12.5357 12.3333 13.2818 12.3333 14.0598H13.8ZM16.7333 19.9264H15.4397V21.3931H16.7333V19.9264ZM16.5603 11.1264H15.2667V12.5931H16.5603V11.1264Z' fill='#0063AA' />
                            </g>
                            <defs>
                              <clipPath id='clip0_133_252'>
                                <rect width={22} height={22} fill='white' transform='translate(5 5.25977)' />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <span>live:b496662486007759</span>
                      </li>
                    </ul>
                  </div>
                  <div className='qr-code'>
                    <img src='/assets/images/contact/qr-code.jpg' alt='' />
                  </div>
                  <div className='social'>
                    {/* <h4>{trans.contact.keep_in_touch}</h4> */}
                    <ul>
                      <li className='facebook'>
                        <a href='https://www.facebook.com/TCOM.Corporation' target={'_blank'}>
                          <svg width={33} height={33} viewBox='0 0 33 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <circle cx='16.5' cy='16.5' r='16.5' fill='#354093' />
                            <path d='M20.1116 10.2951H21.9233V7.13974C21.6107 7.09674 20.5358 7 19.2839 7C16.6718 7 14.8825 8.643 14.8825 11.6627V14.4419H12V17.9693H14.8825L14.8825 26.845H18.4165V17.9701H21.1824L21.6215 14.4427H18.4157V12.0125C18.4165 10.993 18.6911 10.2951 20.1116 10.2951Z' fill='white' />
                          </svg>
                        </a>
                      </li>

                      <li className='linkedin'>
                        <a href='https://www.linkedin.com/company/tcom-corporation' target={'_blank'}>
                          <svg width={33} height={33} viewBox='0 0 33 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <path d='M16.4999 0C25.6131 0 33 7.38787 33 16.5001C33 25.6122 25.6131 33 16.4999 33C7.38674 33 0 25.6121 0 16.5001C0 7.38798 7.38685 0 16.4999 0Z' fill='#0177B4' />
                            <path d='M9.29779 22.671H12.3874V12.3729H9.29779V22.671ZM21.3346 12.0162C19.8351 12.0162 18.4935 12.5637 17.5417 13.7724V12.339H14.4407V22.6711H17.5417V17.0837C17.5417 15.9029 18.6235 14.751 19.9785 14.751C21.3336 14.751 21.6677 15.9029 21.6677 17.0549V22.67H24.7574V16.8249C24.7573 12.7648 22.8351 12.0162 21.3346 12.0162ZM10.8282 11.3437C11.6821 11.3437 12.3751 10.6507 12.3751 9.79681C12.3751 8.94292 11.6821 8.25 10.8282 8.25C9.97428 8.25 9.28125 8.94303 9.28125 9.79692C9.28125 10.6508 9.97428 11.3437 10.8282 11.3437Z' fill='white' />
                          </svg>
                        </a>
                      </li>
                      <li className='youtube'>
                        <a href='https://www.youtube.com/channel/UCmeadb8H2pD_05cFz0qvDVw' target={'_blank'}>
                          <svg width='33' height='33' viewBox='0 0 33 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <circle cx='16.5' cy='16.5' r='16.5' fill='#FF0000' />
                            <path d='M24.6452 12.8745C24.5484 12.5115 24.3587 12.1805 24.095 11.9146C23.8313 11.6487 23.5028 11.4572 23.1425 11.3592C21.8163 11 16.5 11 16.5 11C16.5 11 11.1837 11 9.85748 11.3573C9.49703 11.4549 9.16842 11.6463 8.90465 11.9123C8.64089 12.1783 8.45126 12.5095 8.3548 12.8726C8 14.2102 8 17 8 17C8 17 8 19.7898 8.3548 21.1255C8.55022 21.8631 9.12701 22.4439 9.85748 22.6408C11.1837 23 16.5 23 16.5 23C16.5 23 21.8163 23 23.1425 22.6408C23.8749 22.4439 24.4498 21.8631 24.6452 21.1255C25 19.7898 25 17 25 17C25 17 25 14.2102 24.6452 12.8745ZM14.8114 19.5605V14.4395L19.2132 16.9809L14.8114 19.5605Z' fill='white' />
                          </svg>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className='col-12 col-md-6'>
                <div className='form'>
                  <Form ref={formRef}>
                    <div className='form-group'>
                      {/* <label>{trans.contact.name}</label> */}
                      <Form.Item
                        name='name'
                        rules={[{ required: true, message: '氏名を入力してください' }]}
                      >
                        <input type='text'
                          onBlur={(e) => trimInput('name', e)}
                          className='form-control'
                          placeholder='氏名' />
                      </Form.Item>
                    </div>
                    <div className='form-group'>
                      <Form.Item
                        name='email'
                        rules={[
                          {
                            validator: (_, value) => {
                              if (!value || value.trim() === '') {
                                return Promise.reject('メールアドレスを入力してください');
                              }
                              if (!validateEmailWithoutSpecial(value)) {
                                return Promise.reject('メールアドレスを正しく入力してください');
                              }
                              return Promise.resolve();
                            }
                          }
                        ]}
                      >
                        <input type='text'
                          onBlur={(e) => trimInput('email', e)}
                          className='form-control'
                          placeholder='メールアドレス' />
                      </Form.Item>
                    </div>
                    <div className='form-group'>
                      <Form.Item
                        name='mobile'
                        rules={[
                          {
                            validator: (_, value) => {
                              if (!value || value.trim() === "") {
                                return Promise.reject("電話番号を入力してください");
                              }
                              else if (isNaN(value)) {
                                return Promise.reject(
                                  ' 電話番号を正しく入力してください',
                                );
                              }
                              return Promise.resolve();
                            }
                          }
                        ]}
                      >
                        <input
                          type='text'
                          onBlur={(e) => trimInput('mobile', e)}
                          className='form-control'
                          placeholder='電話番号' />
                      </Form.Item>
                    </div>
                    <div className='form-group'>
                      <Form.Item
                        name='title'
                        rules={[
                          { required: true, message: 'タイトルを入力してください' }
                        ]}
                      >
                        <input type='text'
                          onBlur={(e) => trimInput('title', e)}
                          className='form-control'
                          placeholder='タイトル' />
                      </Form.Item>
                    </div>
                    <div className='form-group'>
                      <Form.Item
                        name='purpose'
                        rules={[{ required: true, message: '連絡の目的を選択してください' }]}
                      >
                        <select className='form-control' name id>
                          <option disabled selected>連絡の目的</option>
                          <option value='見積もり'>見積もり</option>
                          <option value='カウンセリングを依頼する'>カウンセリングを依頼する</option>
                          <option value='協力する'>協力する</option>
                          <option value='リクルート'>リクルート</option>
                          <option value='他の'>他の</option>
                        </select>
                      </Form.Item>
                    </div>
                    <div className='form-group'>
                      <Form.Item
                        name='note'
                        rules={[{ required: true, message: ' お問い合わせ内容を入力してください' }]}
                      >
                        <textarea
                          onBlur={(e) => trimInput('note', e)}
                          className='form-control' p
                          placeholder='お問い合わせ内容'
                          defaultValue={""} />
                      </Form.Item>
                    </div>
                    <div className='custom-file'>
                      <Form.Item
                        name='fileItem'
                        // rules={[{ required: true, message: '添付ファイルを選択してください' }]}
                        rules={[
                          {
                            validator: (_, value) => {
                              if (!fileupload) {
                                return Promise.reject("添付ファイルを選択してください");
                              }
                              return Promise.resolve();
                            }
                          }
                        ]}
                      >
                        <input onChange={e => {
                          setFile(e.target.files[0]);
                          formRef.current.validateFields(['fileItem']);
                        }}
                          ref={fileref}
                          type='file'
                          className='custom-file-input form-control'
                          id='customFile'
                          accept='.png,.jpg,.svg,.gif,.xls,.xlsx,.pdf,.doc,.docx,.webp,.jpeg'
                        />
                        <label className='custom-file-label' htmlFor='customFile' data-content={fileref?.current?.files[0]?.name ? fileref?.current?.files[0]?.name : '添付ファイル'}>
                          <svg width={20} height={21} viewBox='0 0 20 21' xmlns='http://www.w3.org/2000/svg'>
                            <path d='M16.383 10.1262C16.5004 10.2447 16.5662 10.4047 16.5662 10.5715C16.5662 10.7383 16.5004 10.8983 16.383 11.0168L9.96897 17.4152C9.14846 18.2357 8.0356 18.6967 6.87522 18.6967C5.71484 18.6967 4.60199 18.2357 3.78147 17.4152C2.96096 16.5947 2.5 15.4819 2.5 14.3215C2.5 13.1611 2.96096 12.0482 3.78147 11.2277L11.5393 3.36836C11.8263 3.06571 12.171 2.82359 12.5531 2.65626C12.9352 2.48894 13.3469 2.3998 13.764 2.39409C14.181 2.38839 14.595 2.46623 14.9815 2.62304C15.3681 2.77986 15.7193 3.01246 16.0145 3.30714C16.3097 3.60182 16.5429 3.95261 16.7004 4.33885C16.8579 4.72508 16.9365 5.13894 16.9315 5.55602C16.9265 5.9731 16.8381 6.38497 16.6715 6.76734C16.5048 7.14971 16.2633 7.49485 15.9612 7.78242L8.20335 15.6418C8.02994 15.8179 7.82317 15.9576 7.59513 16.0529C7.36709 16.1481 7.12235 16.1969 6.87522 16.1965C6.50371 16.1974 6.14031 16.0879 5.83112 15.882C5.52193 15.676 5.28089 15.3828 5.1386 15.0396C4.9963 14.6965 4.95916 14.3187 5.03189 13.9544C5.10462 13.5901 5.28394 13.2556 5.5471 12.9934L12.0549 6.38398C12.1112 6.32082 12.1798 6.26975 12.2564 6.23386C12.3331 6.19798 12.4162 6.17804 12.5008 6.17524C12.5853 6.17244 12.6696 6.18685 12.7485 6.21759C12.8273 6.24833 12.8991 6.29476 12.9594 6.35406C13.0198 6.41337 13.0675 6.48432 13.0996 6.5626C13.1318 6.64089 13.1477 6.72489 13.1464 6.8095C13.1451 6.89412 13.1266 6.97758 13.0921 7.05485C13.0575 7.13211 13.0077 7.20156 12.9455 7.25898L6.43772 13.8762C6.37848 13.9342 6.33139 14.0035 6.2992 14.08C6.26701 14.1564 6.25036 14.2385 6.25022 14.3215C6.24928 14.4878 6.31383 14.6477 6.42991 14.7668C6.54988 14.8815 6.70926 14.9458 6.87522 14.9465C7.0415 14.9474 7.20147 14.8829 7.32053 14.7668L15.0705 6.89961C15.2466 6.7262 15.3864 6.51943 15.4816 6.29139C15.5768 6.06335 15.6257 5.81861 15.6252 5.57148C15.6261 5.19997 15.5167 4.83657 15.3107 4.52738C15.1047 4.21819 14.8116 3.97715 14.4684 3.83486C14.1252 3.69256 13.7475 3.65542 13.3832 3.72815C13.0188 3.80088 12.6843 3.9802 12.4221 4.24336L4.6721 12.1105C4.36945 12.3976 4.12733 12.7423 3.96001 13.1244C3.79268 13.5064 3.70354 13.9182 3.69783 14.3352C3.69213 14.7523 3.76997 15.1663 3.92678 15.5528C4.0836 15.9393 4.3162 16.2905 4.61088 16.5857C4.90556 16.8809 5.25636 17.1142 5.64259 17.2716C6.02882 17.4291 6.44268 17.5077 6.85976 17.5028C7.27684 17.4978 7.68871 17.4094 8.07108 17.2427C8.45345 17.0761 8.79859 16.8346 9.08616 16.5324L15.4924 10.1262C15.6109 10.0088 15.7709 9.94297 15.9377 9.94297C16.1045 9.94297 16.2645 10.0088 16.383 10.1262Z' fill='#0063AA' />
                          </svg>
                        </label>
                      </Form.Item>
                    </div>
                    <div className='text-right'>
                      <button onClick={OnSubmit} type='submit'>
                        {trans.contact.btn_submit}
                        <svg width={68} height={34} viewBox='0 0 68 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
                          <path fillRule='evenodd' clipRule='evenodd' d='M66.7595 18.2849C67.0863 17.958 67.27 17.5147 67.27 17.0525C67.27 16.5902 67.0863 16.1469 66.7595 15.82L51.9704 1.03091C51.6435 0.704052 51.2002 0.520426 50.7379 0.520425C50.2757 0.520425 49.8324 0.704051 49.5055 1.03091C49.1787 1.35777 48.995 1.80109 48.995 2.26334C48.995 2.72559 49.1787 3.1689 49.5055 3.49576L61.3195 15.3098L2.57763 15.3073C2.34845 15.3073 2.12152 15.3525 1.9098 15.4402C1.69807 15.5279 1.50569 15.6564 1.34364 15.8185C1.18159 15.9805 1.05305 16.1729 0.965346 16.3846C0.877646 16.5964 0.832511 16.8233 0.832511 17.0524C0.832509 17.2816 0.877648 17.5086 0.965346 17.7203C1.05305 17.932 1.18159 18.1244 1.34364 18.2864C1.50569 18.4485 1.69807 18.577 1.9098 18.6647C2.12152 18.7524 2.34845 18.7976 2.57763 18.7976L61.3195 18.7951L49.5055 30.6091C49.1787 30.936 48.995 31.3793 48.995 31.8416C48.995 32.3038 49.1787 32.7471 49.5055 33.074C49.8324 33.4008 50.2757 33.5845 50.7379 33.5845C51.2002 33.5845 51.6435 33.4009 51.9704 33.074L66.7595 18.2849Z' fill='#FDFDFD' />
                        </svg>
                      </button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>


  );
}
